import { render, staticRenderFns } from "./CustomerIbanModal.vue?vue&type=template&id=0ca45f47&"
import script from "./CustomerIbanModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerIbanModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports